import { ManageIban } from '../utils/ManageIban';
import EnableIfRadioSelected from '../utils/EnableIfRadioSelected';
// Form id is suffixed with the content element uid, so match by prefix
const SELECTOR = 'form[id^="sbs-mitgliedschaft-"]';
export default class SbsMitgliedschaft {
    constructor() {
        const form = document.querySelector(SELECTOR);
        if (!form)
            throw new Error(`SbsMitgliedschaft: Form with selector ${SELECTOR} not found.`);
        this.form = form;
        this.features = [
            new ManageIban(`#${this.form.id}-radiobutton-2`),
            // "Anderer Betrag" is only editable when the "anderer Betrag" option is selected
            new EnableIfRadioSelected(`#${this.form.id}-text-7`, `#${this.form.id}-radiobutton-1-5`),
        ];
        for (const feature of this.features) {
            // try catch is important here because we don't want a broken feature to impact the others
            try {
                if (feature.start) {
                    feature.start();
                }
            }
            catch (e) {
                console.error('SbsMitgliedschaft: Feature failed to start', e);
            }
        }
    }
    static isPresentOnPage() {
        return document.querySelector(SELECTOR) !== null;
    }
}
